export const SCHEMA_SET = 'SCHEMA_SET';
export const SCHEMA_REQUEST = 'SCHEMA_REQUEST';
export const SCHEMA_REQUEST_ERROR = 'SCHEMA_REQUEST_ERROR';
